import { render } from "./ProfileWork.vue?vue&type=template&id=5bcc2e52"
import script from "./ProfileWork.vue?vue&type=script&lang=js"
export * from "./ProfileWork.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__